// extracted by css-extract-rspack-plugin
export default {"Body":"Body-x4MjQ5","body":"Body-x4MjQ5"};